import type { VFXEffectConfig, VFXPrimitive } from '../../VFXEffectRegistry';
import { abilityPalette } from '../../abilityPalette';
import { DEMON_ARMOR_STATE_STYLE as armor } from '../statusPresentation.config';

const palette = abilityPalette('demon_armor')?.palette ?? [];

/** Angular shadow plates and slate seams; no full-body fill or absorption cue. */
export const WARLOCK_STATE_VFX: VFXEffectConfig[] = [{
  id: 'demon_armor_state',
  name: 'Demon Armor State',
  category: 'status',
  description: 'Faceted shadow shoulders with separate angular slate side outlines',
  followTarget: 'player',
  primitives: [-1, 1].flatMap((side): VFXPrimitive[] => [
    {
      type: 'polygon',
      polygonPoints: armor.shoulderPoints.map((value, index) => index % 2 === 0 ? value * -side : value),
      offsetX: side * armor.shoulderX, offsetY: armor.shoulderY,
      color: palette[0], alpha: armor.plateAlpha, depth: armor.depth,
    },
    {
      type: 'line', linePoints: armor.outlinePoints.map(({ x, y }) => ({ x: x * -side, y })),
      lineWidth: armor.outlineWidth, color: palette[1], alpha: armor.outlineAlpha, depth: armor.depth + 1,
    },
    {
      type: 'line', linePoints: armor.accentPoints.map(({ x, y }) => ({ x: x * -side, y })),
      lineWidth: armor.accentWidth, color: palette[2], alpha: armor.outlineAlpha, depth: armor.depth + 1,
    },
  ]),
}];
